import {
  Button,
} from '@mui/material';
import { filterUndefined } from '../../utils/FilterUndefinedObject';
import './UrlLink.scss';

const defaultProps = {
  title: '',
  url: '',
  subUrls: [],
  className: '',
  dataTest: '',
};
export default function UrlLink(props) {
  const { title, url, subUrls, className, dataTest, ...rest } = { ...defaultProps, ...filterUndefined(props) };
  const isSelected = [url, ...(subUrls || [])].includes(`/${window.location.pathname.split('/')[1]}`);
  return (
    <Button
      sx={{
        textTransform: 'capitalize',
      }}
      {...rest}
      className={`${className} url-link ${isSelected ? 'url-selected-link' : ''}`}
      data-test={`url-list-${dataTest || title}`}
    >
      {title}
    </Button>
  );
}
